import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { HtmlContent } from "../../../HtmlContent";
import styles from "./TextBlock.style";

const TextBlockStyled = styled.section((props) => ({ ...styles(props) }));

const TextBlock = ({
    className,
    title,
    titleHighlight,
    titleRest,
    titleTagComponent: TitleTag,
    description,
    bottomSpacing,
    isReverse,
    isNegative,
    ...rest
}) => {
    if (!title && !description) {
        return null;
    }

    return (
        <TextBlockStyled
            className={className}
            noTitle={!title && !titleHighlight && !titleRest}
            bottomSpacing={bottomSpacing}
            isNegative={isNegative}
            {...rest}
        >
            {titleHighlight && titleRest && (
                <div className="textBlock_title">
                    {isReverse ? (
                        <>
                            {`${titleRest} `}
                            <span className={isNegative ? "accentQuaternary" : "accentPrimary"}>
                                {titleHighlight}
                            </span>
                        </>
                    ) : (
                        <>
                            <span className="accentPrimary">{titleHighlight}</span>
                            {` ${titleRest}`}
                        </>
                    )}
                </div>
            )}
            {title && (
                <HtmlContent
                    content={title}
                    className="textBlock_title"
                    wrapperComponent={TitleTag}
                />
            )}
            {description && (
                <HtmlContent
                    content={description}
                    className="textBlock_description"
                    wrapperComponent="div"
                />
            )}
        </TextBlockStyled>
    );
};

TextBlock.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    titleHighlight: PropTypes.string,
    titleRest: PropTypes.string,
    titleTagComponent: PropTypes.elementType,
    description: PropTypes.string,
    bottomSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isReverse: PropTypes.bool,
    isNegative: PropTypes.bool,
};

TextBlock.defaultProps = {
    className: undefined,
    title: undefined,
    titleHighlight: undefined,
    titleRest: undefined,
    titleTagComponent: "div",
    description: undefined,
    bottomSpacing: 0,
    isReverse: false,
    isNegative: false,
};

export default TextBlock;
